import React from "react"
import { motion } from "framer-motion"

export default function GalleryGrid() {
  const images = [
    { id: 1, src: "/images/gallery-1.jpg", title: "Chambre Massage Luxe" },
    { id: 2, src: "/images/gallery-2.jpg", title: "Experience Hammam" },
    { id: 3, src: "/images/gallery-3.jpg", title: "Soins Visage" },
    { id: 4, src: "/images/gallery-4.jpg", title: "Espace Détente" },
    { id: 5, src: "/images/gallery-5.jpg", title: "Piscine Intérieur" },
    { id: 6, src: "/images/rituel.jpg", title: "Thérapie de Bien-être" },
    { id: 7, src: "/images/gallery-7.jpg", title: "Salle de Remise En Forme" },
    { id: 8, src: "/images/gallery-8.jpg", title: "Soins des Ongles" },
  ]

  return (
    <section className="py-20 lg:py-28 bg-[#f9f6f1]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {images.map((img, index) => (
            <motion.div
              key={img.id}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: index * 0.05 }}
              viewport={{ once: true }}
              className="group relative overflow-hidden rounded-[28px] shadow-lg"
            >
              {/* Image */}
              <div className="h-72 overflow-hidden">
                <img
                  src={img.src}
                  alt={img.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-110 transition duration-700"
                />
              </div>

              {/* Overlay */}
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/50 transition duration-500" />

              {/* Text */}
              <div className="absolute bottom-0 left-0 w-full p-5 translate-y-6 group-hover:translate-y-0 transition duration-500 opacity-0 group-hover:opacity-100">
                <h3 className="text-white text-lg font-semibold">
                  {img.title}
                </h3>

                <p className="text-gray-300 text-sm mt-1">
                  Expérience de Spa
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}